import axios from "axios";
import { base_url } from "./axiosConfig";

export const axiosPrivate = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export const axiosPublic = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosPrivate.interceptors.request.use(
  (config) => {
    config.headers["X-App-Type"] = "user";

    return config;
  },
  (error) => Promise.reject(error),
);

function isOnLoginPage() {
  return window.location.pathname === "/login";
}

function isOnRateLimitPage() {
  return window.location.pathname === "/rate-limit-exceeded";
}

const USER_TYPE = "user";

axiosPrivate.interceptors.response.use(
  (response) => response,
  async (error) => {
    const prevRequest = error?.config;

    if (isOnLoginPage()) {
      return Promise.reject(error);
    }

    if (error?.response?.status === 429) {
      window.location.href = isOnRateLimitPage() ? "/" : "/rate-limit-exceeded";
      return Promise.reject(error);
    }

    if (error?.response?.status === 401 && !prevRequest?._retry) {
      prevRequest._retry = true;

      const isTokenExpired = error?.response?.data?.tokenExpired;

      const userType = error?.response?.data?.userType || USER_TYPE;

      if (isTokenExpired) {
        try {
          await axios.post(
            `${base_url}/${userType}/refresh-token`,
            {},
            {
              withCredentials: true,
            },
          );

          return axiosPrivate(prevRequest);
        } catch (refreshError) {
          try {
            const { store } = require("../store/store");
            const { logout } = require("../store/auth/authSlice");

            store
              .dispatch(logout())
              .unwrap()
              .then(() => {
                const {
                  default: authService,
                } = require("../store/auth/authService");
                authService.clearLocalStorage();

                window.location.href = "/login?expired=true";
              })
              .catch(() => {
                window.location.href = "/login?expired=true";
              });
          } catch (storeError) {
            window.location.href = "/login?expired=true";
          }

          return Promise.reject(refreshError);
        }
      }
    }

    return Promise.reject(error);
  },
);

export default axiosPrivate;
